import { isProductionEnvironment } from '../../defines';
import { ProjectErrors, ProjectErrorType } from './types';

const createProjectErrorObject = (
  code: ProjectErrors | 'custom' | string,
  message: string,
  details?: string,
): ProjectErrorType => ({
  code,
  message,
  details,
  getUserMessage: () => {
    if (!isProductionEnvironment) {
      const detailsText = details && details?.length > 0 ? ` [Details: ${details}]` : '';
      if (message === code) {
        return `${message}${detailsText}`;
      }
      return `${message}${detailsText} [${code}]`;
    }
    return message;
  },
});

export const getProjectErrorForCode = (code: ProjectErrors, details?: string): ProjectErrorType => {
  const message = code.valueOf();
  return createProjectErrorObject(code, message, details);
};

export const getProjectErrorFromRawError = (error: Error): ProjectErrorType => {
  const code = 'custom';
  // @ts-ignore
  const message = ProjectErrors[error] || ProjectErrors.generic.valueOf();
  const details = error.message;
  return createProjectErrorObject(code, message, details);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isProjectError = (object: any): ProjectErrorType | undefined => {
  return object !== undefined && object !== null && typeof object === 'object' && 'getUserMessage' in object
    ? (object as ProjectErrorType)
    : undefined;
};
